let sHtmlDeletePhoto = '<div><a href="javascript:void(0);" id="btn-delete-cert">Удалить фото</a><br><br></div>';
let sHtmlBtnDeleteStudentPhotoForCert = '';

function createFileFromBase64URL(sBase64Url) {
    let blobBin = atob(sBase64Url.split(',')[1]);
    let array = [];
    for (let i = 0; i < blobBin.length; i++) {
        array.push(blobBin.charCodeAt(i));
    }
    let file = new Blob([new Uint8Array(array)], { type: 'image/png' });
    return file;
}

function checkExistStudentPhotoForCertificate() {
    let xhr = new XMLHttpRequest();
    xhr.open('GET', '/get_student_photo_for_certificate', false);
    xhr.send();
    return (xhr.status == 200) ? true : false;
}

function initCroppie() {
    $('#upload-photo-cert').croppie({
        viewport: { width: 100, height: 140 },
        boundary: { width: 130, height: 170 },
        url: '/get_student_photo_for_certificate',
        showZoomer: true,
        enableOrientation: true,
    });
}

function changeBtnOnInterface(){
    if ($('#upload').val() != '') {
        $('#upload-photo-cert').croppie('result', {
            type: 'canvas',
            size: 'original',
            format: "png",
            quality: 1
        }).then(function(result) {

            let fileImage = createFileFromBase64URL(result);

            let formData = new FormData();
            formData.append('_token', $('meta[name="csrf-token"]').attr('content'));
            formData.append('photo_udo', fileImage);
            formData.append('external_source', 'certificate');

            $.ajax({
                url: '/save_photo_for_udo',
                type: 'POST',
                data: formData,
                contentType: false,
                processData: false,
                success: function(response) {
                    console.log(response);
                    switch (response.status) {
                        case 'success':
                            if ($('#btn-delete-cert').length == 0)
                                $('#btn-upload-photo-cert').prepend(sHtmlDeletePhoto);
                            $('#btn-upload-cert').removeClass('hide-tr');
                            $('#btn-save-cert').addClass('hide-tr');
                            toastr.success(response.message);
                            break;
                        case 'error':
                            toastr.error(response.message);
                            break;
                        default:
                            toastr.warning('Произошла непредвиденная ошибка, попробуйте еще раз');
                    }
                },
            });

        });
    } else {
        toastr.info('Выберите изображение');
    }
}

$('.upload-photo-udo').on('click', function(ev) {

    if (checkExistStudentPhotoForCertificate()) {
        sHtmlBtnDeleteStudentPhotoForCert = sHtmlDeletePhoto;
    }else{
        sHtmlBtnDeleteStudentPhotoForCert = '';
    }

    Swal.fire({
        title: 'Добавьте фото для удостоверений',
        showCloseButton: true,
        showCancelButton: false,
        showConfirmButton: false,
        html: `
                <div>
                    <div class="row">
                        <div class="col-3 mt-70">
                        <a href="javascript:void(0);" onclick="$('#upload-photo-cert').croppie('rotate', -90)">&#8635;</a>
                        </div>
                        <div class="col-6">
                        <div id="upload-photo-cert"></div>
                        </div>
                        <div class="col-3 mt-70">
                        <a href="javascript:void(0);" onclick="$('#upload-photo-cert').croppie('rotate', 90)">&#8634;</a>
                        </div>
                    </div>
                    <div>
                        <div id="btn-upload-photo-cert" style="text-align: center;">
                        ` + sHtmlBtnDeleteStudentPhotoForCert + `
                        <label class="btn btn-success" id="btn-upload-cert">
                            Выбрать фото
                        <input type="file" id="upload" style="display: none;">
                        </label>
                        <button class="btn btn-success upload-result-photo-cert hide-tr" id="btn-save-cert" style="position: relative; left: 0px;">Загрузить</button>
                        </div>
                    </div>
                </div>
            `,
    });
    initCroppie();
    $('#upload-photo-cert').croppie('setZoom', 0);
});

$(document).on('change', '#upload', function() {
    $('#btn-upload-cert').addClass('hide-tr');
    $('#btn-save-cert').removeClass('hide-tr');
    $('#btn-delete-cert').parent().detach();
    let reader = new FileReader();
    reader.onload = function(e) {
        $('#upload-photo-cert').croppie('bind', {
            url: e.target.result
        }).then(function() {
            console.log('jQuery bind complete');
        });
    }
    reader.readAsDataURL(this.files[0]);
});



$(document).on('click', '.upload-result-photo-cert', function() {
    changeBtnOnInterface();
});

$('#upload-photo-cert').on('update.croppie', function(ev, cropData) {
    changeBtnOnInterface();
});

$(document).on('click', '#btn-delete-cert', function() {
    $.ajax({
        url: '/delete_photo_for_udo',
        type: 'POST',
        _token: $('meta[name="csrf-token"]').attr('content'),
        success: function(response) {
            // if(response.status == 'success') $('#btn-delete-cert').parent().detach();
            Swal.fire({ icon: response.status, title: response.message });
        }
    });
});
